__turbopack_context__.v({
  "AlignCenter": "eC9ura_AlignCenter",
  "BlueGreen": "eC9ura_BlueGreen",
  "ButtonWrapper": "eC9ura_ButtonWrapper",
  "Container": "eC9ura_Container",
  "ImageContainer": "eC9ura_ImageContainer",
  "ImageGradient": "eC9ura_ImageGradient",
  "ImageInner": "eC9ura_ImageInner",
  "ImageWrapper": "eC9ura_ImageWrapper",
  "PinkBlue": "eC9ura_PinkBlue",
  "PinkOrange": "eC9ura_PinkOrange",
  "PinkPurple": "eC9ura_PinkPurple",
  "PublishedDate": "eC9ura_PublishedDate",
  "PurpleBlue": "eC9ura_PurpleBlue",
  "Root": "eC9ura_Root",
  "Tagline": "eC9ura_Tagline",
  "Text": "eC9ura_Text",
  "TextContainer": "eC9ura_TextContainer",
  "TitleBottom": "eC9ura_TitleBottom",
  "TitleContainer": "eC9ura_TitleContainer",
  "TitleTop": "eC9ura_TitleTop",
  "Visible": "eC9ura_Visible",
});
